const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideohandledningarSmallTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m642.4 756-1.4.1H387.4c-2 0-4.1.7-6.5 1.1l-.8.1c-.2-.3-.5-.7-1.4-1.5-1.9-.6-3-.9-4.2-.9H64c-1.7 0-3.4.7-5 1-18-2.8-32.7-15-34.5-34.5.5-2.4.7-4 .7-5.5V118.6c0-1.9-.6-3.8-1-5.7.9-8.5 4.8-15 10.7-21.6C44.3 81 55.5 79.2 68.2 79.2H955c9 0 17.5 1 25 6.2 8.6 5.8 14 13.6 15.6 25v606.4c0 2.3.7 4.6 1 6.9a38.1 38.1 0 0 1-35.7 32 16 16 0 0 0-4.4-.8h-309c-1.7 0-3.4.7-5.1 1M70 129c-.5 2.6-1.5 5.2-1.5 7.9V660c0 2.5 1.5 5 2.4 7.8l.2 1.1 1.5 1.2a19 19 0 0 1 2.4 2.6c1.9.2 3.8.7 5.8.7h860.9c2 0 4-1 6.5-2 1.2-1.8 2.3-3.5 4.4-5.5.3-2.3 1-4.6 1-6.8V136.4c0-2.2-1.3-4.5-2.3-7.4l-5.3-6c-2.5-.1-5-.5-7.6-.5H82.7c-2.3 0-4.6 1.2-7.5 2.1-.9.5-1.7 1-3.4 1.7-.3.7-.6 1.4-1.7 2.6Zm662 732.5 7.9 2.6c11.9 4.3 16.2 14.6 19.4 26.2-.5 15.7-.6 30.7-.7 45.7 0 0 0-.2-.1 0-.4 0-.5.1-.6.2l.4.7c-.5.8-1 1.5-2 2.1-.7.1-1 .4-1.2.6l-.6-.1-479-.1-9.6.2v-.3c-.7-.6-1.2-.8-1.7-1-1-1.8-2-3.6-2.4-6.1.5-8.4.8-16.1.7-23.8 0-4.4-.6-8.8-1-13.3-.3-13.8 9.7-26.6 22.4-32a63.5 63.5 0 0 1 26-3.8h47c1.6-.1 2.1-.2 3 .2 2.8.5 5.1.8 7.5.8h295.7c1 0 1.5 0 2.3.4 22.5.5 44.5.6 66.6.8Z",
    style: {
      fill: "#83a1b0",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.7 860.3H367.4c-2.4 0-4.7-.3-7.4-1.3 0-2.8.2-4.8.5-6.7l3.9-22c.4-2.9.8-5.7 1.7-9.1 2.5-6.5 5-12.3 6.2-18.3 1.1-5.1 1-10.5 1.3-15.8a61 61 0 0 1 2-7.9c2.3-7.7 4-14.9 5.6-22 2-.4 4.2-1 6.2-1h253.3a4 4 0 0 1 1.1 3.2l-1.3 1.7 2 1-.2.4 7.2 30.7 11.2 47.6c.4 1.9 1.2 3.6 1.6 6.3 0 5 .2 9 .4 13.2Z",
    style: {
      fill: "#96b4c2",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243137",
    d: "M266.2 940c2.9-.4 6-.6 9.2-.6h479.2c-2.2.9-5 2.3-7.6 2.3H274c-2.5 0-5-.8-7.8-1.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010E14",
    d: "M996.8 723.1c-.4-1.7-1-4-1-6.3V111c.5 3.8 1.5 8.2 1.5 12.6v584.2c0 5-.2 10-.5 15.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01080D",
    d: "M24.3 113.5c.4 1.3 1 3.2 1 5.1V716c0 1.5-.2 3.1-.6 5-.5-4-.7-8.4-.7-12.8V122.4l.3-9ZM59.6 756c1.1-.4 2.8-1 4.5-1h310.4c1.2 0 2.3.2 3.9.6-40.8.4-82 .5-123 .6L59.6 756Zm583.4 0c1-.4 2.8-1 4.5-1h309.1c1.2 0 2.4.2 4 .6-46.2.4-92.7.5-139.2.6-59.3 0-118.6 0-178.5-.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B1B22",
    d: "M731.9 861c-22 .3-44 .2-66.4-.7l-.4-1.3 56 .4c3.6 0 7.1.8 10.8 1.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010E14",
    d: "M759 935.7a968 968 0 0 1 .2-45 968 968 0 0 1-.2 45Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B1B22",
    d: "M373.3 787.4c0 5 .1 10.4-1 15.5-1.3 6-3.7 11.8-6 17.8 2-11 4.3-22 7-33.3Zm-9.3 43c-1 7.2-2.2 14.5-3.5 21.9l-.9 6.3c-.6.5-1.1.6-2.1.6 1.7-9.6 3.9-19 6.4-28.8Zm285.6-37.5a805 805 0 0 1-7.3-30.4 789 789 0 0 1 7.3 30.4Zm-268.7-35.7c-1.4 7.1-3 14.3-5.1 21.6 1-6.8 2.6-13.7 4.2-21 .1-.5.6-.5.9-.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010E14",
    d: "M261.5 895.7c.4 3.9 1 8.3 1 12.7.1 7.7-.2 15.4-.6 23.4-.4-11.6-.5-23.6-.4-36.1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#344249",
    d: "M665.1 858.5v1.5c-.5.3-1 .3-2 .3-.6-4.1-.9-8.3-.8-12.8 1.1 3.3 2 7 2.8 11Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0B1B22",
    d: "M642.4 761.6c-.6.1-1.2-.2-1.9-.5l1.3-1.3c.4.4.4 1 .6 1.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#243137",
    d: "M755.3 939.5c0-.1.3-.4.6-.5.2.2-.3.5-.6.5Zm-490.9-.9c.3 0 .8.1 1.5.8-.3 0-.8-.2-1.5-.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010E14",
    d: "M758.5 936.7c-.3 0-.5-.3-.6-.5l.6-.3c.3 0 .2.6 0 .8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 668.3v-1c0-1.2 0-1.7.3-2.6.5-2.8.8-5.1.8-7.5V128.3s-.1 0 0 0l.6-.3-.3-1c0-.5.2-.7.2-.9.9-.5 1.7-1 3.5-1.6 15.6-.3 30.4-.6 45.1-.6 31.3 0 62.6.3 94 .3 36.6 0 73.3-.3 110-.3l114.3.3h390.2l117.2-.3c1.5 1.7 3 3.4 4.6 6 .2 108.1.1 215.3.1 322.5l.2 213.8a57.3 57.3 0 0 1-4 5.5c-.9.3-1 .2-1.4-.2a23 23 0 0 0-7.5-1.6H83.6c-2.2 0-4.5 1.4-7 2.2-1 0-1.5-.2-2-.3l-2.3-2.1-1.3-1.4m563.7-439.8-1.8-.6-.5-.7-.9-.6v-.7a34 34 0 0 0-21.6-12.4l-.3-.7-4.5-1.7v-.8c-5.6-2.7-11-6-16.8-8.1a242.4 242.4 0 0 0-52.2-12.6c-7.7-1-15.5-1.3-23.3-1.2-10.5.1-21 .6-31.3 1.8a166 166 0 0 0-28.3 5.4c-10.5 3.1-20.6 7.7-30.8 12-2.4 1-4.3 3.4-7.1 5.8-10.8 6.7-22 12.8-32.1 20.4a216.5 216.5 0 0 0-64.6 80.5c-2 4.6-4 9.2-6.2 13.7a145.2 145.2 0 0 0-11.2 54.2c-.8 17.1.7 34.4 1.5 51.5 0 1.7 2 3.4 3 6-.2 2.5-1 5.2-.4 7.4 2.3 8.1 5 16 7.7 24 .2.4 1.7.5 3.2 1.3 2.5 5.8 4.7 11.8 7.5 17.5a202.7 202.7 0 0 0 68.3 79.3l8.3 4.9.3.7 5.6 3 .4.7a263.2 263.2 0 0 0 56.4 23.2l10.4 2.2.2.9c9.5 1.8 18.8 5.4 29.3 1.5.6 0 1.1.1 1.9 1.1 1.2.5 2.5 1.4 3.6 1.3l36.6-3.3c1.4-.2 2.6-1.5 4.9-2.6 12.8-3.6 25.6-7.3 39.3-11 5.3-2.4 10.6-4.5 15.8-7.1 36-18.2 64.2-44.7 85.8-79.4l2-4.3s0 .2.6-.3c6-13.2 11.9-26.3 18.5-39.6 1-1.7 2.2-3.2 2.6-5 1.8-7.1 3.5-14.3 4.8-21.6 1.7-9.5 4.2-19 4.2-28.5a445 445 0 0 0-3.5-46c-.7-5.9-4-11.5-6.6-17.8L698 302.9l-.2-.7-1-1.7-.3-.9-3.8-6s.2 0 0-.7l-1.3-1.6v-.8l-2.3-2.9s.2 0 0-.7l-1.3-1.6-.1-.8c-1.6-2-3.1-4.2-5-7.1a2714.7 2714.7 0 0 1-24.8-29.2l-.1-.7c-.8-.5-1.6-1-2.3-1.7l-.1-.7c-.9-.5-1.7-1-2.4-1.6v-.7l-6-4.2-.2-.5-1-.6v-.8l-6-4v-.8l-2.7-1v-1l-2-.8-.4-.6Z",
    style: {
      fill: "#b3e1ed",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E3222",
    d: "M946.5 123.5c-38.7.5-77.8.7-116.8.7H439.5l-114.3-.3c-36.7 0-73.4.3-110 .3-31.4 0-62.7-.3-94-.3-14.7 0-29.5.3-44.8.4 1.7-.6 4-1.8 6.3-1.8h855.8c2.5 0 5 .4 8 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393E3C",
    d: "m71 665-.1 2c-.8-2-2.3-4.5-2.3-7V136.8c0-2.7 1-5.3 2-8 .4-.3.5-.2.5.4l-.3 6.5v337.7L71 665Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E3222",
    d: "M952.2 666c-.5-71.1-.5-142.4-.6-213.6V130.3c.8 1.6 2 3.9 2 6.1.2 103 .1 206 .1 309V659c0 2.2-.7 4.5-1.5 7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42311B",
    d: "m946.5 671.9 1 .1c-1.7.5-3.7 1.4-5.7 1.4h-861a20 20 0 0 1-6-1.2c.3-.3.8-.2 2.3 0h863.5l6-.3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#393E3C",
    d: "M72.2 126.2c.4.1.3.3 0 1l-.2 1.2h-.2l-.7.2-.1-.1c.2-.8.5-1.5 1.2-2.3ZM71 668.6c.3 0 .6.3 1 1l-1-1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED4229",
    d: "M390.8 568a200.5 200.5 0 0 1-67.1-78.1c-2.8-5.7-5-11.7-8-18.2a593 593 0 0 1-6.5-24.5c-.2-3.7-.2-7-.7-10a180 180 0 0 1-3-53.9c.7-5.3-.5-11-.8-16.9.2-2.3.2-4.2.7-6l14-46.3c14.8-32 35.7-59 63.8-80.3 10-7.6 21.3-13.7 32.8-20.9 2.3-1.2 3.8-2.1 5.5-2.7 16.1-5.3 32.2-10.5 48.7-15.4 3 .2 5.5.3 8 0 11.4-.8 22.8-1.9 34.3-2.4 3.7-.2 7.9 2.4 11 1.4 5.2-1.7 9.6-.4 14.5.2 5.1.6 10.4.3 16.1.4l51 16.8.2.2c1.7 1 3.2 1.6 4.6 2.2l.2.2c7.3 4.6 14.3 8.7 21.4 12.9l.1.2c.3.6.7.8 1 .7l.7.7 1.8.9v.2c.8.7 1.4 1 2 1.4l.2.3 2.5 1.7.2.3c2 1.7 3.9 3.1 5.8 4.5l.1.2c.4.5.8.7 1.2 1l.1.2c2 1.8 3.9 3.2 5.7 4.7 0 0 0-.2.2.2.8.9 1.6 1.4 2.3 2l.2.3c.8 1 1.5 1.5 2.2 2l.1.3a899.7 899.7 0 0 1 24.7 29.5c1.7 2.9 3.5 5.1 5.3 7.3v.4c.5.9 1 1.4 1.4 2 0 0-.2 0-.2.3a22 22 0 0 0 2.4 3.3v.4c.5.9 1 1.4 1.4 2 0 0-.2 0-.2.4l4.1 6.3-.2.5c.4 1 1 1.4 1.4 1.9l-.2.6c5.5 16.8 11.1 33.1 16.9 49.4.1.4 1 .5 1.6 1 .1.6.1.8-.2 1.4-.3 2.7-.7 5.2-.3 7.4a182 182 0 0 1 1.7 59.8 199 199 0 0 1-16.7 59.8c-2.8 6.3-5.3 12.6-8 19 0 0 0-.2-.4 0-1 1.6-1.5 3-2.2 4.6a209 209 0 0 1-85.2 78.9c-5.2 2.6-10.5 4.7-16.5 6.8-11 2.1-21.3 4.7-31.7 6.8-10.5 2.2-21.2 4.8-31.9 5.4-12 .7-24.2.2-36.2-1.1-12-1.3-24.2-3.3-35.8-6.8-13-4-25.2-10.3-37.8-15.4-2.9-1.2-6-1.8-9-2.6l.1-.5c-2-1.3-4-2.2-6-3.1v-.5c-2.9-2-5.8-3.6-8.6-5.2 0 0-.1 0 0-.2l-.8-.3m50.4-257.3-.5.2-.4 1s.1.2-.7.3a21 21 0 0 1-.8 2l-.7.4c-5 4.7-1.8 10.5-1.8 15.8.3 49.6.8 99.1 1.2 148.7 0 1.7.7 3.4 1.2 5.5v1.3c.4.6.8 1.2 1.3 2.3l.2 1.1 1 .8.2.5 1.5 1c.3.1.5.4.7 1.7 4.8 5.7 12.6 5.2 16.6-.8h.7c.7-.6 1.3-1 2.4-2.2l101-58.9c10.1-6 20.4-11.5 30.3-17.9 10.5-6.7 9.6-19.5-1.2-25.4a1194 1194 0 0 1-29-16.5c-36-21-71.8-42-108-63.8-3.4-3.4-9.8-3.2-11.7.3l-.7.1c-.5.5-1 1-1.6 1.3l-.5.2a4 4 0 0 1-.7 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "M946.4 671.5a21 21 0 0 1-5.8.7L77.5 672c1.6-.8 3.9-2.1 6-2.1 83.9-.2 167.7-.1 251.4-.1h604c2.4 0 4.9.7 7.5 1.6ZM71 129.2c.1-.6.6-.7.8-.8a148917 148917 0 0 1 .3 528.8c0 2.4-.3 4.7-.8 7.5-.4-63.5-.4-127.4-.4-191.3V135.7c0-2 0-4 .2-6.5Zm398.8 65.3-48.3 15.7c-1.7.6-3.2 1.5-5.2 2.5 1.8-1.7 3.7-4.1 6.1-5.2 10.2-4.2 20.3-8.8 30.8-11.9a166 166 0 0 1 28.3-5.4c10.3-1.2 20.8-1.7 31.3-1.8 7.8-.2 15.6.3 23.3 1.2a236.5 236.5 0 0 1 52.2 12.6c5.8 2.1 11.2 5.4 16.8 8.6-16.8-5.2-33.7-10.8-51.5-16.5-7.8-1-14.6-2.5-21.4-3a209.9 209.9 0 0 0-62.4 3.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M406.4 578.1c2.7.5 5.8 1.1 8.7 2.3 12.6 5.1 24.9 11.4 37.8 15.4 11.6 3.5 23.8 5.5 35.8 6.8a219 219 0 0 0 36.2 1.1c10.7-.6 21.4-3.2 32-5.4 10.3-2 20.6-4.7 31.2-6.8-12.6 4-25.4 7.7-39.2 11.5l-44.3 3.5-2.6-.2-28.5-2.5-.3-.3c-3.6-1.2-7-2-10.4-2.7a217 217 0 0 1-56.4-22.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "m716.4 354.9-.1-1.4c-1-4-1.6-7.4-2.3-10.7 2 5.7 5.3 11.3 6 17.2a445 445 0 0 1 3.5 46c0 9.5-2.5 19-4.2 28.5a323 323 0 0 1-4.8 21.7c-.4 1.7-1.7 3.2-2.8 4.5 1.2-6.3 2.6-12.2 4-18.1a204 204 0 0 0 .7-87.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M716 355.2c6.4 29 6.4 58.2-.3 87.4l-4.4 18.2c-6 13.6-12 26.7-18.2 40.1l7.7-18.7c8.7-19 14.3-39 16.7-59.8 2.2-19.9 2.6-40-1.7-59.8-.4-2.2 0-4.7.3-7.4Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "M319 314.2c-4.3 15.3-9 30.7-13.6 46.2-.5 1.8-.5 3.7-.8 6.5-.6 11.7-1.7 22.4-1.5 33 .3 13 1.7 25.8 2.7 38.7l-.1.1c-1-1.6-3-3.3-3-5-.8-17.1-2.3-34.4-1.5-51.5 1-18.4 3.3-37 11.2-54.2 2.1-4.5 4.2-9.1 6.6-13.8Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M713.7 342.5c1 3.6 1.7 7 2.4 10.6-.4.2-1.3 0-1.4-.3-5.8-16.3-11.4-32.6-16.9-49.3 5.3 12.6 10.4 25.6 15.9 39Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "m309.2 447.8 6.3 23.6c-.8.2-2.3.1-2.5-.3-2.7-8-5.4-15.9-7.7-24-.6-2.2.2-5 .4-8 0-.4 0-.4.4-.3a73 73 0 0 1 3 9ZM504.7 607a1166 1166 0 0 1 43.7-3.8c-.8.7-2 2-3.4 2.2l-36.6 3.3c-1.1 0-2.4-.8-3.7-1.7Zm126.8-380.7c-7-3.8-14.1-8-21.4-12.4a31 31 0 0 1 21.4 12.4Zm-157.9 378c9 .4 18.3 1.2 28 2.1-9.2 3.8-18.5.2-28-2.1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M687.8 285a45 45 0 0 1-5-6.6 45 45 0 0 1 5 6.5Zm-296 283.8a71 71 0 0 1 8.4 5 71 71 0 0 1-8.4-5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "M462.9 601.3c3.3.3 6.7 1 10.4 2.2-3.3-.3-6.8-1-10.4-2.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M696.7 300a45.9 45.9 0 0 1-4-6c1.3 1.6 2.6 3.6 4 6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "M645.8 237.1c-1.9-.9-3.8-2.3-5.9-4 1.9 1 4 2.3 6 4Zm7.2 6.1c-2-1-3.8-2.4-5.8-4.2 1.8 1 3.8 2.4 5.7 4.2Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M400.4 574.5c1.8.6 3.8 1.5 5.8 2.9-1.9-.6-3.8-1.6-5.8-2.9Zm290.1-69c.4-1.2 1-2.7 2-4.3-.3 1.3-1 2.7-2 4.3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "M609.8 213.2a15 15 0 0 1-4.5-1.7c1.3.2 2.8.7 4.5 1.7Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M691.4 291a9.7 9.7 0 0 1-2.3-3c.8.5 1.5 1.5 2.3 3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "M639.8 232.4c-.8 0-1.5-.6-2.5-1.3a5 5 0 0 1 2.5 1.3Zm15.6 13.1c-.7-.2-1.5-.7-2.4-1.6.7.2 1.5.7 2.4 1.6Zm2.4 2.4a6 6 0 0 1-2.3-1.7c.7.2 1.5.8 2.3 1.7ZM637 230.4c-.5 0-1.1-.3-1.9-1 .6 0 1.3.3 2 1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M689.2 287.3c-.4-.2-.8-.7-1.3-1.6.4.1.8.7 1.3 1.6Zm3.6 6c-.4-.2-.8-.7-1.3-1.6.4.1.8.7 1.3 1.6Zm5.2 9.2c-.5-.2-1-.7-1.4-1.5.5.1.9.6 1.3 1.5Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "M632.5 227.4c-.2.3-.6.1-1-.5.3-.1.6 0 1 .5Zm2.4 1.5c-.3 0-.7-.1-1.4-.6.3-.2.7 0 1.4.6Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M390.9 568.2c.1-.2.4-.1.6.1 0 .2-.5 0-.6-.1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0E7EE7",
    d: "M647 238.4c-.3.1-.7-.1-1.1-.6.2-.1.5.1 1 .6Zm12 10.8c-.3 0-.6-.1-1.1-.7.2 0 .6.2 1 .7ZM72.2 128.3c-.2 0-.1-.5 0-.8.3 0 .4.3.5.5l-.5.3Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAF9F9",
    d: "M440 488.7v-1.1a9.7 9.7 0 0 0-1.2-2.4v-1.3c0-3.7.4-6.7.4-9.7l-.7-136.7c0-7.8.3-15.6.4-23.3l.2-.1c.7-.8 1-1.4 1.3-2 0 0-.1-.1.2-.2.4-.4.6-.8.8-1.2h.2c.5-.5.8-.8 1-1.2h.2l2-1.4h.3l11.7.5 107.5 63c9.6 5.7 19.3 11.1 29 16.5 11 5.9 11.8 18.7 1.3 25.4-9.9 6.4-20.2 12-30.3 17.9l-101.6 59.3-2.6 1.8h-.4c-5.7 3.1-11 3.6-16.2 0 0-.5-.3-.8-1-1.4l-1.3-1.1-.1-.2a4 4 0 0 0-1.1-1.1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F14317",
    d: "M438.5 314.4c.3 7.5 0 15.3 0 23l.7 136.8c0 3-.3 6-.6 9.4-.4-1.1-1-2.8-1-4.5-.5-49.6-1-99.1-1.3-148.7 0-5.3-3.1-11 2.2-16Zm31.7-119.6a198 198 0 0 1 62-3.5c6.8.5 13.6 2 21 3-4.8 0-10 .3-15.2-.3-4.9-.6-9.3-1.9-14.4-.2-3.2 1-7.4-1.6-11.1-1.4-11.5.5-22.9 1.6-34.3 2.5-2.5.2-5 .1-8-.1Zm-161 252.4-3-8.4c-1.4-13-2.8-26-3-38.8-.3-10.7.8-21.4 1.4-32.7.4 5 1.6 10.7.9 16a180 180 0 0 0 3 53.9c.5 3 .5 6.3.7 10Zm134.3 45.7c5.2 3.2 10.5 2.7 16.2-.4-3.5 6-11.3 6.5-16.2.4Zm13.1-184.7c-3.5.2-7.3 0-11.4-.1 1.4-3.5 7.8-3.7 11.4.1Zm3.9 184.3c.2-.5.9-.9 2-1.4a5 5 0 0 1-2 1.4ZM440 312.1c.1.6-.2 1.2-.8 2-.1-.5.2-1.2.8-2Zm-1.3 173.4c.4.3.8.9 1.2 1.9-.4-.3-.8-.9-1.2-1.9Zm5.6-177.3c-.1.4-.7.8-1.5 1.3.2-.3.7-.8 1.5-1.3ZM440 489c.3 0 .7.2 1.2.8-.3 0-.7-.2-1.1-.8Zm1.3 1.3c.2 0 .5.2 1 .7-.3 0-.6-.2-1-.7Zm-.3-179.5c.2.3 0 .7-.4 1.2-.2-.3 0-.7.5-1.2Zm1.3-1.2c0 .3-.2.6-.7 1.1-.1-.3.1-.6.7-1.1Z",
    style: {
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B7C9D6",
    d: "M662.7 849.1c-53.5-17.2-107-35-160.6-52.6a17342 17342 0 0 0-115.6-37.6c-.5 0-.6-.7-.7-1 2.9-.8 5.8-1.7 8.8-1.7h250.2c4.7 22.7 8.9 45.5 13 68.3l4.9 24.6Z",
    style: {
      strokeWidth: 1.185
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideohandledningarSmallTransparent);
export default __webpack_public_path__ + "static/media/videohandledningar_small_transparent.3b130cc31e1242f998471e6663ca270e.svg";
export { ForwardRef as ReactComponent };